import { IACDLEvent } from '../../../../../services/eventBus.service';

export const ClarificationAddedEventType = Symbol('CLARIFICATION_ADDED_EVENT');

export class ClarificationAddedEvent implements IACDLEvent {
  get type(): symbol {
    return ClarificationAddedEventType;
  }
}
